import React, { useEffect, useState } from "react";
import App from "./App";
import Login from "./components/Login";
import "./App.css";
import { dbURL } from "./components/global";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";

// Show login window if the user is not logged in, or the App if the user has logged in; pass username & type to App.
function Init() {
  const navigate = useNavigate();
  const location = useLocation();

  // The login variables controlling app access
  const [loggedIn, setLoggedIn] = useState(() => false);
  const [username, setUsername] = useState(false);
  const [userType, setUserType] = useState(false);

  // Check login at load
  useEffect(() => {
    // Check login
    async function checkLogIn() {
      try {
        // Send credentials by post
        const response = await fetch(dbURL + "checkLogin.php", {
          credentials: "include",
        });
        const result = await response.json();
        // Set the login variables
        if (result.user) setUsername(result.user);
        if (result.userType) setUserType(result.userType);
        if (result.loggedIn) {
          setLoggedIn(() => true);
          location.pathname === "/" && navigate(`/app`);
          //   console.log(location.pathname, "logged in");
        }
      } catch (err) {
        if (!err.ok) console.error("Nie zalogowano");
        //console.log("Navigated");
        navigate("/");
        //console.log(location.pathname, "not logged in");
      }
    }

    checkLogIn();
    return () => {};
  }, [loggedIn]);

  return (
    <Routes>
      {loggedIn ? (
        <Route
          path="/app/*"
          element={
            <App
              user={username}
              userType={userType}
              setLoggedIn={setLoggedIn}
              loggedIn={loggedIn}
            />
          }
        ></Route>
      ) : (
        ""
      )}
      <Route
        path="/"
        element={<Login loggedIn={loggedIn} setLoggedIn={setLoggedIn} />}
      ></Route>
    </Routes>
  );
}

export default Init;
